var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileP(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9497 14.4937C12.8164 14.4803 12.6564 14.4803 12.5097 14.4937C9.33641 14.387 6.81641 11.787 6.81641 8.58699C6.81641 5.32033 9.45641 2.66699 12.7364 2.66699C16.0031 2.66699 18.6564 5.32033 18.6564 8.58699C18.6431 11.787 16.1231 14.387 12.9497 14.4937Z",
    stroke: "#8B659C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6167 5.33301C25.2034 5.33301 27.2834 7.42634 27.2834 9.99967C27.2834 12.5197 25.2834 14.573 22.79 14.6663C22.6834 14.653 22.5634 14.653 22.4434 14.6663",
    stroke: "#8B659C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.28328 19.413C3.05661 21.573 3.05661 25.093 6.28328 27.2397C9.94995 29.693 15.9633 29.693 19.6299 27.2397C22.8566 25.0797 22.8566 21.5597 19.6299 19.413C15.9766 16.973 9.96328 16.973 6.28328 19.413Z",
    stroke: "#8B659C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1895 26.667C26.1495 26.467 27.0561 26.0803 27.8028 25.507C29.8828 23.947 29.8828 21.3737 27.8028 19.8137C27.0695 19.2537 26.1761 18.8803 25.2295 18.667",
    stroke: "#8B659C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileP);
export default __webpack_public_path__ + "static/media/profile-p.cece136acc8fe6181d8ba156f1a20e2c.svg";
export { ForwardRef as ReactComponent };